import "./terms.css";

function Terms() {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <h2>1. Acceptance of Terms and Conditions</h2>
      <p>
        By using the Insight Headlines, you agree to be bound by these Terms and
        Conditions. If you do not agree to these Terms and Conditions, please do
        not use the App. These Terms and Conditions may be updated from time to
        time, and your continued use of the App will constitute your acceptance
        of any changes.
      </p>
      <h2>2. Job Search</h2>
      <p>
        <span className="highlight">2.1 User Responsibility:</span> The App
        provides job search functionality to help users find employment
        opportunities. You agree to use the job search feature responsibly and
        for legitimate job-seeking purposes.
      </p>
      <p>
        <span className="highlight">2.2 Accuracy:</span> While we strive to
        provide accurate job listings, we cannot guarantee the accuracy,
        completeness, or reliability of the information. Users are encouraged to
        verify job details with the original job posting source.
      </p>
      <p>
        <span className="highlight">2.3 Links to Original Source:</span> The App
        may provide links to external job posting websites. We are not
        responsible for the content, accuracy, or availability of these external
        websites. Users are encouraged to review the terms and conditions of the
        original job posting source.
      </p>
      <h2>3. Resume Creation</h2>
      <p>
        <span className="highlight">3.1 User Responsibility:</span> Users have
        the option to create resumes through the App. You are responsible for
        the accuracy and completeness of the information included in your
        resume.
      </p>
      <h2>4. News App</h2>
      <p>
        <span className="highlight">4.1 News Data Source:</span> The news
        content provided in the App is sourced from newsdata.io API, a
        third-party service. We do not control the content from this source and
        are not responsible for its accuracy, timeliness, or reliability.
      </p>
      <p>
        <span className="highlight">4.2 Links to Original Source:</span> The App
        may provide links to original news sources for reference. We encourage
        users to visit these original sources to verify information and to
        review their terms and conditions.
      </p>
      <p>
        <span className="highlight">5.1 Prohibited Activities:</span> Users are
        prohibited from engaging in any activities that may harm the App, its
        functionality, or other users. This includes but is not limited to
        unauthorized access, distribution of malware, and spamming.
      </p>
      <p>
        <span className="highlight">5.2 Compliance with Laws:</span> Users must
        comply with all applicable laws and regulations while using the App
      </p>
      <h2>6. Termination</h2>
      <p>
        We reserve the right to terminate or suspend your access to the App at
        our discretion, with or without notice, if we believe you have violated
        these Terms and Conditions.
      </p>
      <h2>7. Disclaimer of Warranty</h2>
      <p>
        The App is provided "as is" and "as available" without any warranties of
        any kind, either express or implied, including but not limited to the
        implied warranties of merchantability, fitness for a particular purpose,
        or non-infringement.
      </p>
      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, we shall not be liable for any
        direct, indirect, incidental, special, consequential, or punitive
        damages, or any loss of profits or revenues, whether incurred directly
        or indirectly, or any loss of data, use, goodwill, or other intangible
        losses, resulting from (a) your use or inability to use the App, (b) any
        unauthorized access to or use of our servers and/or any personal
        information stored therein, (c) any interruption or cessation of
        transmission to or from the App, (d) any bugs, viruses, trojan horses,
        or the like, which may be transmitted to or through the App by any third
        party, or (e) any errors or omissions in any content or for any loss or
        damage of any kind incurred as a result of your use of any content
        posted, emailed, transmitted, or otherwise made available via the App.
      </p>
      <h2>9. Governing Law</h2>
      <p>
        These Terms and Conditions shall be governed by and construed in
        accordance with the laws of India.
      </p>
      <h2>10. Contact Information</h2>
      <p>
        If you have any questions or concerns about these Terms and Conditions,
        please contact us at feedback.insightheadlines@outlook.com
      </p>
      <h2 className="highlight">10.1 Original Source Links</h2>
      Powered by{" "}
      <a href="https://newsdata.io/" target="_blank">
        NewsData.io API
      </a>
      <p>
        By using the App, you acknowledge that you have read, understood, and
        agree to these Terms and Conditions.
      </p>
    </div>
  );
}

export default Terms;
